import { render, staticRenderFns } from "./addProblem.vue?vue&type=template&id=33bfb0e0&scoped=true&"
import script from "./addProblem.vue?vue&type=script&lang=js&"
export * from "./addProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfb0e0",
  null
  
)

export default component.exports